class Accordion {
  // Style Links with animated border
  constructor() {

    // define variables
    const accordionButtons = document.querySelectorAll('.accordion-item__button');

    accordionButtons.forEach(element => {
      element.addEventListener('click', () => {
        const isAccordionVisible = element.parentElement.classList.contains('is-expanded');
        console.log('parent element', element.parentElement);
        console.log('is the accordion visible', isAccordionVisible);

        if(isAccordionVisible) {
          element.parentElement.classList.remove('is-expanded');
          element.parentElement.classList.add('is-collapsed');
        } else {
          element.parentElement.classList.add('is-expanded');
          element.parentElement.classList.remove('is-collapsed');
        }
      })
    }); 
  }
}

export default Accordion;